// AUTO GENERATED FILE. DO NOT EDIT.
  import PageOrApp, { getServerSideProps as getSSP } from 'tenants/phongvu/desktop/products/[sku]'

  

  export const getServerSideProps = getSSP;
  export default PageOrApp;